import { render, staticRenderFns } from "./Devotionals-Marker.vue?vue&type=template&id=7613f159&"
import script from "./Devotionals-Marker.vue?vue&type=script&lang=js&"
export * from "./Devotionals-Marker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports